import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DateAdapter } from '@angular/material';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataManagementService, DBService, Logger, LoggingService, LoginService, TranslateService } from 'vas-mobile-api';

import { DataExchangeService } from '../services/dataexchange.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})

export class SettingsComponent implements OnInit, OnDestroy {

  settingsForm: FormGroup;
  rawForm: any;
  private ngUnsubscribe = new Subject<void>();

  private logger: Logger;
  public supportedLanguages: Array<string>;
  public languages: Object = {};

  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private db: DBService,
    private des: DataExchangeService,
    private loggingService: LoggingService,
    private dataManageService: DataManagementService,
    public loginService: LoginService,
    private router: Router,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.logger = this.loggingService.getLogger(SettingsComponent.name);
  }

  ngOnInit() {

    this.settingsForm = new FormGroup({
      name: new FormControl(''),
      userclass: new FormControl(''),
      currentIP: new FormControl(''),
      currentPlantName: new FormControl(''),
      currentLanguage: new FormControl('')
    });

    this.setFormValues();
    this.requestLanguages();
    // this.supportedLanguages = this.translate.getSupportedLanguages();
    this.des.changeTitelBarName('MENU_SETTINGS');
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private setFormValues() {

    const surnameP = this.dataManageService.getUserID();
    const userclassP = this.dataManageService.getUserClass();
    const currServerP = this.dataManageService.getCurrentServer();
    const plantCodeP = this.dataManageService.getPlantCode();

    Promise.all([surnameP, userclassP, currServerP, plantCodeP]).then((values) => {
      this.settingsForm.patchValue({ name: values[0] });
      this.settingsForm.patchValue({ userclass: values[1] });
      this.settingsForm.patchValue({ currentIP: values[2].ip });
      this.settingsForm.patchValue({ currentPlantName: values[3] });
      this.settingsForm.patchValue({ currentLanguage: this.translate.getLanguage() });
    });

    this.settingsForm.get('currentLanguage').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      this.logger.debug('setting language to', value);
      this.translate.setLanguage(value);
      if (value === 'AR') {
        this.des.changeViewMode('rtl');
      } else {
        this.des.changeViewMode('ltr');
      }

      let localeExtended = 'en-US';
      switch (value) {
        case 'DE':
          localeExtended = 'de-DE';
          break;
        case 'AR':
          localeExtended = 'ar-SA';
          break;
      }
      this.dateAdapter.setLocale(localeExtended);

    });

  }

  public logOut() {
    this.router.navigate(['login']);
    this.loginService.logout();
  }

  public requestLanguages() {
    this.logger.info('Sent request for languages ');

    this.supportedLanguages = this.translate.getSupportedLanguages();

    // Achtung können auch verdreht sein und dann?
    this.db.getItem('sprachen').then((language) => {
      this.languages = language || {};
      // this.model.languages = selectedLang;
      // this.ready = true;
    }).catch((e) => {
      // this.ready = true;
      throw e;
    });
  }

}
